import { Flex } from "@chakra-ui/layout";
import { Box, Tag, Text } from "@chakra-ui/react";
import { Col, Row, Empty } from "antd";
import InputMoney from "components/Input/InputMoney/index";
import InputSearch from "components/Input/InputSearch";
import { ImportarConsumoUnidades } from "core/features/consumo/typings";
import { UnidadeSimplesPaginateResponse } from "features/unidades/typings/unidade";
import { useMemo, useState } from "react";
import { Control, UseFormSetValue } from "react-hook-form";
import { FixedSizeList } from "react-window";
import Field from "ui/components/Input/Field";

function FormUnidades({
  allUnidades,
  control,
  setValue,
}: {
  allUnidades: UnidadeSimplesPaginateResponse[];
  control: Control<ImportarConsumoUnidades, any>;
  setValue: UseFormSetValue<ImportarConsumoUnidades>;
}) {
  const [search, setSearch] = useState("");

  const _unidades = useMemo(
    () =>
      search
        ? allUnidades?.filter(
            (unidade) =>
              unidade.numero.toLowerCase().includes(search.toLowerCase()) ||
              unidade.blocoQuadra?.nome.includes(search.toLowerCase())
          )
        : allUnidades,
    [allUnidades, search]
  );

  const item = useMemo(
    () =>
      ({ index, style }: { index: number; style: any }) => {
        const _unidade = _unidades?.[index];
        return (
          <Flex
            h={"50px"}
            as={Row}
            key={_unidade?.id}
            alignItems="center"
            borderBottomWidth={1}
            borderBottomColor="gray.100"
            style={style}
          >
            <Box as={Col} xs={18}>
              <Flex gap={2} alignItems="center" mr={4}>
                {_unidade?.blocoQuadra ? (
                  <Flex mt="2px" fontSize="12px" fontWeight="bold">
                    <Tag> {_unidade?.blocoQuadra.nome}</Tag>
                  </Flex>
                ) : null}

                <Flex> {_unidade?.numero}</Flex>
              </Flex>
            </Box>

            <Box as={Col} xs={6}>
              <Field
                name={`unidades.${_unidade?.id}`}
                control={control}
                render={({ field, isInvalid }) => (
                  <InputMoney
                    isInvalid={isInvalid}
                    decimalScale={3}
                    decimalsLimit={3}
                    {...field}
                  />
                )}
              />
            </Box>
          </Flex>
        );
      },
    [_unidades, control]
  );

  if (!allUnidades.length) {
    return <Empty description="Aguardando importação da planilha" />;
  }

  return (
    <Flex flexDir="column" flex={1} w="100%">
      <Text mb={2} fontSize={16} fontWeight="medium">
        Consumo por unidade
      </Text>
      <InputSearch
        defaultValue={search}
        onSearch={(q) => setSearch(q ?? "")}
        placeholder="Pesquisar unidade ou proprietário"
        maxW="100%"
        rounded="6px"
      />

      <Box
        as={Row}
        gutter={16}
        mt={4}
        mb={1}
        borderBottomWidth={1}
        borderBottomColor="gray.100"
      >
        <Box as={Col} sm={18}>
          <Text>Unidade</Text>
        </Box>

        <Box as={Col} sm={6}>
          <Text textAlign="right">Medida atual</Text>
        </Box>
      </Box>

      <FixedSizeList
        itemCount={_unidades?.length ?? 0}
        itemSize={50}
        height={440}
        width="100%"
        className="custom-scroll-bar"
      >
        {item}
      </FixedSizeList>
    </Flex>
  );
}

export default FormUnidades;
